/**
 * Swaps a truncated text preview for the full text in place, and back again.
 * Expects [data-description-preview], [data-description-full] and
 * [data-description-toggle] buttons inside the element.
 */
class ExpandableDescription extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.preview = this.querySelector('[data-description-preview]');
    this.full = this.querySelector('[data-description-full]');

    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const toggle = event.target.closest('[data-description-toggle]');
    if (!toggle) return;

    const expand = this.full.hidden;
    this.preview.hidden = expand;
    this.full.hidden = !expand;

    // Expanding moves focus to the start of the full text, not to "Read less"
    // at its end, so a long description doesn't scroll away from where reading
    // begins. Collapsing returns focus to "Read more".
    const visible = expand ? this.full : this.preview;
    const focusTarget = expand ? this.full : this.preview.querySelector('[data-description-toggle]');
    focusTarget.focus({ preventScroll: true });
    if (visible.getBoundingClientRect().top < 0) {
      visible.scrollIntoView({ block: 'nearest' });
    }
  }
}

if (customElements.get('expandable-description') === undefined) {
  customElements.define('expandable-description', ExpandableDescription);
}
